<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-input v-model="query['no']" placeholder="placeholder.loadingOrderNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-select v-model="query['orderStatus']" :options="orderStatus" placeholder="business.label.orderStatus" @change="refresh"/>
        <vxe-input v-model="query['dockNo']" placeholder="business.label.dock" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['vehicleNo']" placeholder="business.label.vehicleNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['driver']" placeholder="business.label.driver" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['driverPhone']" placeholder="business.label.phone" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-date-range-picker v-model="query.range" linked-panels placeholder="business.label.invoiceTime" type="date" @change="refresh"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
        <vxe-button content="button.expConfirm" icon="vxe-icon-upload" status="info" @click="exp"/>
      </template>
      <vxe-table ref="table" :data="data" :export-config="{}" :loading="loading">
        <vxe-table-column fixed="left" sortable title="business.label.index" type="seq" width="40"/>
        <vxe-column field="order.invoiceTime" sortable title="business.label.invoiceTime" width="170"/>
        <vxe-column field="order.no" sortable title="business.label.loadingOrderNo" width="120"/>
        <vxe-column field="orderType.name" title="business.label.orderType" width="120"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:orderStatus}" field="order.orderStatus" sortable title="business.label.orderStatus" width="100"/>
        <vxe-column field="order.operator" sortable title="business.label.maker" width="100"/>
        <vxe-column field="order.deliverer" sortable title="business.label.deliver" width="100"/>
        <vxe-column field="issue.issuer" sortable title="business.label.issuer" width="100"/>
        <vxe-column field="issue.issueTime" sortable title="business.label.issueTime" width="170"/>
        <vxe-column field="dock.no" sortable title="business.label.dock" width="150"/>
        <vxe-column field="vehicle.no" sortable title="business.label.vehicleNo" width="150"/>
        <vxe-column field="order.driver" sortable title="business.label.driver" width="100"/>
        <vxe-column field="order.driverPhone" sortable title="business.label.phone" width="200"/>
        <vxe-column field="vehicle.type" sortable title="business.label.vehicleType" width="150"/>
        <vxe-column field="order.vehicleInPlaceStatus" sortable title="business.label.vehicleInPlaceStatus" width="150"/>
        <vxe-column field="order.departureTime" sortable title="business.label.departureTime" width="170"/>
        <vxe-column field="order.notes" sortable title="business.label.notes" width="150"/>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :loading="loading" :page-size="size" :total="contentSize" @page-change="pageChange"/>
      </template>
    </vxe-card>
  </div>
</template>

<script>
import { findAll } from '@/api/Api'
import moment from 'moment'
import { getEnums, getOptions } from '@/utils/util'

export default {
  name: 'LoadingOrderQuery',
  data() {
    return {
      loading: false,
      data: [],
      query: {
        'no': '',
        orderStatus: undefined,
        'dockNo': '',
        'vehicleNo': '',
        'driver': '',
        'driverPhone': '',
        range: [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
      },
      owners: [],
      orderStatus: [],
      page: 1,
      size: 20,
      contentSize: 0
    }
  },
  created() {
    findAll('partyFactory', { available: true, 'type.ordinal': 1 }).then(res => {
      if (res.success) {
        this.owners = getOptions(res.result)
      }
      return getEnums('OrderStatus')
    }).then(result => {
      this.orderStatus = result
    })
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      this.loading = true
      const args = Object.assign({}, this.query)
      if (args.range.length > 0) {
        args['dateFilter'] = { start: args.range[0], end: args.range[1] }
      } else {
        args['dateFilter'] = null
      }
      findAll('loadingOrderFactory', args, this.page, this.size).then(res => {
        if (res.success) {
          this.data = res.result
          this.contentSize = res.contentSize
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    reset() {
      this.query = {
        'no': '',
        orderStatus: undefined,
        'dockNo': '',
        'vehicleNo': '',
        'driver': '',
        'driverPhone': '',
        range: [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
      }
      this.refresh()
    },
    exp() {
      this.$refs.table.openExport()
    }
  }
}
</script>